<template>

  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <el-form-item label="说明" >
        <div>
          <div>团队将不超过三代（包含自己），如下</div>
          <div>A用户(1单)-B用户(2单)-C用户(3单)-D用户(1单)</div>
          <div> A用户(1单)-E用户(4单)</div>
          <div>A团队-11单</div>
          <div>B团队-6单</div>
        </div>
      </el-form-item>

      <el-form-item label="是否开启" prop="is_coupon">
        <el-switch v-model="form.is_status"></el-switch>
      </el-form-item>
      <el-form-item label="团队档次奖" >
        <el-button size="small" type="primary" @click="addAchievement" >新增档次</el-button>
        <el-table :data="form.achievement_list" border size="mini" style="width: 100%;margin-top: 20px;">
            <el-table-column prop="name" label="名称" width="200">
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input style="width: 100px;" v-model="scope.row.name"  placeholder="请输入名称"></el-input>
                </div>
              </template>

            </el-table-column>
            <el-table-column prop="name" label="单数"  width="500">
              <template v-slot="scope">
                <div style="float: left;">
                  <el-input style="width: 200px;" v-model="scope.row.price" type="number" placeholder="请输入金额">
                    <template slot="prepend">
                      档次/单：
                    </template>
                  </el-input>
                </div>
                
                <div style="float: left;margin-left: 20px;">
                  <el-input style="width: 200px;" v-model="scope.row.fy" type="number" placeholder="请输入返佣金额">
                    <template slot="prepend">
                      返佣金额/元
                    </template>
                  </el-input>
                </div>

                <div style="clear: both;"></div>
                

              </template>
            </el-table-column>
            <el-table-column prop="name" label="操作"  width="100">
              <template v-slot="scope">
                <div style="color: blue;" @click="delAchievement(scope.$index)">删除</div>

              </template>
            </el-table-column>
          </el-table>
      </el-form-item>
    </el-form>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>
  </div>
</template>
<script>
import uacApi from '@/api/uac.js';
export default {
  data() {
    return {
      form: {
        achievement_list:[],
        is_status:false,
      },
      setting: [],
      loading: false
    };
  },
  created() {
    /*获取列表*/
    this.getSetting();
  },
  methods: {
    /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      uacApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          self.form = data.data.vars.values;
          if( !this.form.achievement_list){
            this.form.achievement_list = [];
          }
        })
        .catch(error => {});
    },
    addAchievement(){
      this.form.achievement_list.push({
        "name":"",
        "ratio":0,
        "price":0,
      });
    },
    delAchievement(index){
      this.form.achievement_list.splice(index,1)
    },
    /*点击保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      uacApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/uac/setting/getSetting.vue